import { useTranslation } from "react-i18next"
import { Modal, Button } from "@cividao/components"
import styles from "./index.module.css"

interface ConfirmModalProps {
  title: string
  message: string
  confirmLabel?: string
  cancelLabel?: string
  confirmColor?: "primary" | "accent" | "error"
  isLoading?: boolean
  onConfirm: () => void
  onClose: () => void
}

export function ConfirmModal({
  title,
  message,
  confirmLabel,
  cancelLabel,
  confirmColor = "primary",
  isLoading = false,
  onConfirm,
  onClose,
}: ConfirmModalProps) {
  const { t } = useTranslation("common")

  return (
    <Modal title={title} onClose={onClose}>
      <div className={styles.content}>
        <p className={styles.message}>{message}</p>
        <div className={styles.actions}>
          <Button type="outline" onClick={onClose} isDisabled={isLoading}>
            {cancelLabel ?? t("cancel")}
          </Button>
          <Button type="filled" color={confirmColor} onClick={onConfirm} isLoading={isLoading}>
            {confirmLabel ?? t("confirm")}
          </Button>
        </div>
      </div>
    </Modal>
  )
}
